/* PR Studio cart drawer: the quick-add strip (cro#CART-02).
   1. Submit: POST the quick-add form to add.js, then let the theme's <cart-form> refresh itself
      through its own "theme:cartchanged" event (quantities, totals, ladder, header count).
   2. Carousel: one item per view. Phones swipe (native scroll snap). Desktop gets the arrows
      (inside the box, disabled at either end, only when there is more than one item), pointer
      drag, and shift+wheel / horizontal wheel. Nothing moves on its own: the old auto-advance
      ran while the drawer was still closed, so the strip was on item 3 before anyone opened it.
   A deferred asset on purpose: the theme's PageSpeed packer (snippets/scripts.liquid) lazyloads
   every later script on Linux browsers until a mouse move, section {% javascript %} included. */
;(function () {
  if (window.__prCart) return; window.__prCart = true;

  /* Arriving with ?cart=open (layout/theme.liquid sends /cart here): open the drawer the way the
     header icon does, once the theme has bound it, and take the flag off the URL so a refresh
     does not reopen it. Up to ~5s of retries; the drawer is detected by the popup becoming visible. */
  if (/[?&]cart=open\b/.test(location.search)) {
    var tries = 0;
    var open = function () {
      var link = document.querySelector('.cart-link, a[href$="/cart"]');
      if (link) link.click();
      var drawer = document.querySelector('.cart-drawer');
      var popup = drawer && (drawer.closest('.cc-popup') || drawer);
      var shown = popup && getComputedStyle(popup).display !== 'none' && getComputedStyle(popup).visibility !== 'hidden' && popup.getBoundingClientRect().width > 0;
      if (shown || ++tries > 25) {
        try { var u = new URL(location.href); u.searchParams.delete('cart'); history.replaceState(null, '', u.pathname + (u.search || '') + u.hash); } catch (e) {}
        return;
      }
      setTimeout(open, 200);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(open, 150); });
    else setTimeout(open, 150);
  }

  /* 1. submit ----------------------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    /* the drawer's quick-add strip and the Season 9 free-gift row post the same way */
    if (!form || !form.classList || !(form.classList.contains('cqa__form') || form.classList.contains('pr-gift__form'))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) btn.disabled = false;
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } }));
      })
      .catch(function () { if (btn) btn.disabled = false; });
  }, true);

  /* 2. carousel --------------------------------------------------------------------------- */
  function stripOf(el) { return el && el.closest ? el.closest('.cart-quick-adds__carousel') : null; }
  function itemWidth(strip) { var c = strip.querySelector('.cqa'); return c ? c.getBoundingClientRect().width : strip.clientWidth; }
  function index(strip) { var w = itemWidth(strip); return w ? Math.round(strip.scrollLeft / w) : 0; }
  function count(strip) { return strip.querySelectorAll('.cqa').length; }
  function goTo(strip, i, instant) {
    var n = count(strip); if (i < 0) i = 0; if (i > n - 1) i = n - 1;
    strip.scrollTo({ left: i * itemWidth(strip), behavior: instant ? 'auto' : 'smooth' });
  }
  function sync(car) {
    var strip = car.querySelector('[data-qa-strip]'); if (!strip) return;
    var n = count(strip), i = index(strip);
    car.classList.toggle('has-many', n > 1);
    /* dots under the strip, one per add-on (David 2026-10-01) */
    var dots = car.querySelector('[data-qa-dots]');
    if (!dots) { dots = document.createElement('div'); dots.className = 'cart-quick-adds__dots'; dots.setAttribute('data-qa-dots', ''); car.appendChild(dots); }
    if (dots.childElementCount !== n) { dots.innerHTML = ''; for (var d = 0; d < n; d++) { var b = document.createElement('button'); b.type = 'button'; b.className = 'cart-quick-adds__dot'; b.setAttribute('data-qa-dot', d); b.setAttribute('aria-label', 'Item ' + (d + 1)); dots.appendChild(b); } }
    for (var k = 0; k < dots.children.length; k++) dots.children[k].classList.toggle('is-active', k === i);
    dots.hidden = n < 2;
    var prev = car.querySelector('[data-qa-prev]'), next = car.querySelector('[data-qa-next]');
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= n - 1;
  }
  function setup(car) {
    if (car.__prCar) return; car.__prCar = true;
    var strip = car.querySelector('[data-qa-strip]'); if (!strip) return;
    sync(car);
    strip.addEventListener('scroll', function () { sync(car); }, { passive: true });

    /* arrows */
    car.addEventListener('click', function (e) {
      var dot = e.target.closest ? e.target.closest('[data-qa-dot]') : null;
      if (dot) { e.preventDefault(); goTo(strip, parseInt(dot.getAttribute('data-qa-dot'), 10)); return; }
      var b = e.target.closest ? e.target.closest('[data-qa-prev],[data-qa-next]') : null;
      if (!b) return;
      e.preventDefault();
      goTo(strip, index(strip) + (b.hasAttribute('data-qa-next') ? 1 : -1));
    });

    /* pointer drag (mouse only; touch keeps native swipe) */
    var drag = null;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest && e.target.closest('button, select, input')) return;
      drag = { x: e.clientX, left: strip.scrollLeft, moved: false, id: e.pointerId };
    });
    strip.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 4) return;
      if (!drag.moved) { drag.moved = true; strip.classList.add('is-dragging'); try { strip.setPointerCapture(drag.id); } catch (err) {} }
      strip.scrollLeft = drag.left - dx;
      e.preventDefault();
    });
    function endDrag(e) {
      if (!drag) return;
      var moved = drag.moved; drag = null;
      if (!moved) return;
      try { strip.releasePointerCapture(e.pointerId); } catch (err) {}
      strip.classList.remove('is-dragging');
      goTo(strip, Math.round(strip.scrollLeft / itemWidth(strip)));
      /* a drag is not a click: swallow the click that follows on links */
      var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); strip.removeEventListener('click', swallow, true); };
      strip.addEventListener('click', swallow, true);
      setTimeout(function () { strip.removeEventListener('click', swallow, true); }, 50);
    }
    strip.addEventListener('pointerup', endDrag);
    strip.addEventListener('pointercancel', endDrag);

    /* wheel: horizontal wheel/trackpad scrolls natively; shift+wheel and a plain wheel over the
       strip with a mouse turn into one item per notch */
    strip.addEventListener('wheel', function (e) {
      var horizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
      if (!horizontal && !e.shiftKey) return;               /* vertical wheel: the drawer scrolls */
      e.preventDefault();
      var d = horizontal ? e.deltaX : e.deltaY;
      if (Math.abs(d) < 2) return;
      if (strip.__wheelLock) return;
      strip.__wheelLock = true; setTimeout(function () { strip.__wheelLock = false; }, 350);
      goTo(strip, index(strip) + (d > 0 ? 1 : -1));
    }, { passive: false });
  }
  function scan() {
    var cars = document.querySelectorAll('.cart-quick-adds__carousel');
    for (var i = 0; i < cars.length; i++) setup(cars[i]);
  }

  /* whenever the drawer opens, the strip starts at the first item */
  document.addEventListener('theme:open-cart-drawer', function () {
    setTimeout(function () { var strips = document.querySelectorAll('.cart-drawer [data-qa-strip]'); for (var i = 0; i < strips.length; i++) goTo(strips[i], 0, true); }, 60);
  });

  function boot() {
    scan();
    try {
      new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) { if (m[i].addedNodes && m[i].addedNodes.length) { scan(); break; } } })
        .observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    window.addEventListener('resize', function () { var cars = document.querySelectorAll('.cart-quick-adds__carousel'); for (var i = 0; i < cars.length; i++) sync(cars[i]); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
